export default __webpack_public_path__ + "static/media/ic_3d.a97adb6b.svg";